import { useSearchParams } from 'react-router-dom';
import { ESearchParams } from 'common/const';

export const useSearchParamsHook = () => {
  const [params, setParams] = useSearchParams();

  const setSearchParam = (key: ESearchParams, value: string | number | boolean, replace = false) => {
    setParams(
      (params) => {
        params.set(key, value.toString());
        return params;
      },
      { replace },
    );
  };

  const removeSearchParam = (key: ESearchParams, replace = false) => {
    setParams(
      (params) => {
        params.delete(key);
        return params;
      },
      { replace },
    );
  };

  const getSearchParam = (key: ESearchParams) => {
    return params.get(key);
  };

  return { searchParams: params, setSearchParam, removeSearchParam, setParams, getSearchParam };
};
